module.exports = __webpack_public_path__ + "img/5f7980549857269a27cb884dedbfa75d.png";